import React, { useState } from "react"
import { toast } from "react-toastify";
import {  REACT_APP_VAM_CONTEXT_DOCUMENT, REACT_APP_VAM_ENDPOINT } from "../urls";
import { axiosRequest } from "../service";

const FileUpload = (props) => {
  const {validtype,mandatory, addedFiles, setAddedFiles, text, module, roleDataCookie, doctypeName, pay, tran_id} = props
  const [fileSize, setfileSize] = useState(0);
  const [isFileLoading, setIsFileLoading] = useState(false);
  

  const uploadFile = () => {
    if (isFileLoading) {
        return
    }
    //const file = document.getElementById('fileInput').files[0];
      const fileInput = document.getElementById('fileInput');

      const uploadFiles = () => {

          const formData = new FormData();
          const files = fileInput.files;

          if (files && files.length > 0) {
              for (let i = 0; i < files.length; i++) {
                  formData.append('files', files[i]);
              }

              setIsFileLoading(true);
              axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}/ci/upload/bulk?userId=${String(roleDataCookie?.userID)}&tranId=${tran_id}&docType=${doctypeName}`, formData)
                  .then(response => {
                      for (let i = 0; i < files.length; i++) {
                          setAddedFiles(prevFiles => [...prevFiles, { name: files[i].name, id: response.data.docIdList[i], size: Number(files[i].size) }]);
                          toast.success("File Uploaded Successfully.");
                        } 
                      setIsFileLoading(false);
                  }).catch(error => {
                      console.log(error)
                      toast.error("Something Went Wrong. ");
                      setIsFileLoading(false);
                  });
          } else {
              toast.error("No files selected.");
          }
      }

    if(module !== "litigation" && doctypeName === "claim"){
        uploadFiles();
    } else {
        for (let index = 0; index < fileInput.files.length; index++) {        
            const file = fileInput.files[index];
            if (!file) {
                setIsFileLoading(false);
                return;
            }
            const formData = new FormData();
            if (file) {
                // if((file.size/51200).toFixed(4) > 50){
                //     toast.error("File Size Should be Less Than 50MB.")
                //     return
                // }
                const fileType = file.type;
                //setfileSize(Number((file.size / (1024 * 1024)).toFixed(4)) + Number(fileSize))
                //alert(Number((file.size / (1024 * 1024)).toFixed(4))+Number(fileSize))
                if ((Number((file.size / (1024 * 1024)).toFixed(4)) + Number(fileSize)) > 50) {
                    toast.error("File Size Should be Less Than 50MB.")
                    setfileSize(Number(fileSize))
                    return;
                }
                if (validtype.includes(fileType)) {
                    setfileSize((Number((file.size / (1024 * 1024)).toFixed(4)) + Number(fileSize)))
                    formData.append('userId', String(roleDataCookie?.userID));
                    formData.append('file', file);
                    formData.append('docType', doctypeName);
                    formData.append('tranId', tran_id);
                        setIsFileLoading(true)
                        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}/upload`, formData).then(data => {
                            // fileInput.files.length > 0 ? setAddedFiles([...addedFiles, { name: file.name, id: data.data, size: Number(file.size) }]) : setAddedFiles([{ name: file.name, id: data.data, size: Number(file.size)}])
                            setAddedFiles(prevFiles => [...prevFiles, { name: file.name, id: data.data, size: Number(file.size) }]);
                            toast.success("File Uploaded Successfully.")
                            setIsFileLoading(false);
                        }).catch(error => {
                            console.log(error)
                            toast.error("Something Went Wrong. ")
                        }).finally(() => {
                            setIsFileLoading(false);
                            fileInput.value = ""; // Clear the file input
                        });
                }
                else {
                    toast.error("File should be Selected format")
                    setIsFileLoading(false)
                    fileInput.value = ""; // Clear the file input
                    return
                }
            } else {
                setIsFileLoading(false)
            }
        }  
    }  
}

  return (
    <>
       {
        module !== "litigation" ? (
            <>
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <p className="align3Policy" style={{ marginTop: "17px" }}>Attachment{mandatory && <span className='text-danger'>*</span>}</p>
                        <div className="hoverPolicy">
                            <label for="fileInput">
                                <input type="file" id="fileInput" className="w-100" accept="image/*,video/*" hidden onClick={(e) => e.target.value = ""} onChange={() => uploadFile()} multiple />
                                <p className="align6_dataPolicy w-100">
                                    <span className="plusPolicy" style={{ marginLeft: "2px" }} >+</span>
                                    <span className="textPolicy" style={{ marginLeft: "0px" }} >{text}</span>
                                </p>
                            </label>
                            {
                                isFileLoading && (
                                    <span className="spinner-border ms-4" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </span>
                                )
                            }
                            {/* <form>
                                    <input type="file" id="fileInput" name="fileInput"/>
                                    <button type="button" id="uploadButton">Upload</button>
                                </form> */}
                        </div>
                        <div className="align5Policy" style={{ marginLeft: "18px" }}>File Size can not be more than 50 MB</div>
                    </div>
                    <div className={'col-xl-4 col-lg-4 col-md-4 col-sm-12 brief_descriptionPolicy1'}>
                        {
                            addedFiles && addedFiles.length > 0 && (
                                <>
                                    <br></br>
                                    <p className="align3Policy" style={{ marginTop: "-16px" }}>Attached Files</p>
                                    <div className="mb-4"
                                        style={{
                                            height: '100px', // set the desired height of the div
                                            //overflow: 'auto', // this will add scrollbars inside the div
                                            // border: '1px solid #ccc',
                                            marginTop: "-5px",
                                            padding: '10px',
                                            maxHeight: "110px", // Set the maximum height of the textarea
                                            minHeight: "100px",
                                            overflow: "auto", // Add scrollbars when content exceeds the maximum height
                                            resize: "auto"
                                        }}
                                    >
                                        <div
                                            style={{
                                                minHeight: '30px', // ensures the content is taller than the container
                                            }}
                                        >

                                            {
                                                addedFiles.map(file => (
                                                    <div className="align_4_dataPolicy deletePolicy" key={file.id}>
                                                        <span className="hoverPolicy">{file.name}</span>
                                                        <span className="marginPolicy hoverPolicy" onClick={() => { setAddedFiles(prevFiles => prevFiles.filter(list => list.id !== file.id));setfileSize(prevSize => prevSize - Number((file.size / (1024 * 1024)).toFixed(2)));}}>
                                                            <img
                                                                src="/kshemaImages/delete_symbol.png"
                                                                alt="delete"
                                                                height="18px"
                                                                width="auto"
                                                            />
                                                        </span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </>
                            )
                        }
                </div>            
            </>
        ) : (
            <>
           <div className={ pay ? 'col-xl-8 col-lg-8 col-md-6 col-sm-12 d-flex ms-5' : 'col-xl-10 col-lg-10 col-md-4 col-sm-12 d-flex'}>
                <div className="hoverPolicy">
                <p className="align3Policy" style={{ marginTop: "17px" }}>Attachment{mandatory && <span className='text-danger'>*</span>}</p>
                    <label for="fileInput">
                        <input type="file" id="fileInput" className="w-100" accept="image/*,video/*" hidden onClick={(e) => e.target.value = ""} onChange={() => uploadFile()} />
                        <p className="align6_dataPolicy w-100">
                            <span className="plusPolicy" style={{ marginLeft: "2px" }} >+</span>
                            <span className="textPolicy" style={{ marginLeft: "0px" }} >{text}</span>
                        </p>
                    </label>
                    {
                        isFileLoading && (
                            <span className="spinner-border ms-4" role="status">
                                <span className="sr-only">Loading...</span>
                            </span>
                        )
                    }

                <div className="align5Policy" style={{ marginLeft: "18px" }}>File Size can not be more than 50 MB</div>
                </div>
                    <div className="ms-5">
                        {
                            addedFiles && addedFiles.length > 0 && (
                                <>
                                    <br></br>
                                    <p className="align3Policy ms-3" style={{ marginTop: "-16px" }}>Attached Files</p>
                                    <div className="attached_file_alignPolicy"
                                        style={{
                                            height: '100px', // set the desired height of the div
                                            //overflow: 'auto', // this will add scrollbars inside the div
                                            // border: '1px solid #ccc',
                                            marginTop: "-5px",
                                            padding: '10px',
                                            maxHeight: "110px", // Set the maximum height of the textarea
                                            minHeight: "100px",
                                            width: "250px",
                                            minWidth: "12%",
                                            maxWidth: "30%",
                                            overflow: "auto", // Add scrollbars when content exceeds the maximum height
                                            resize: "auto"
                                        }}
                                    >
                                        <div
                                            style={{
                                                // Add your content styles here
                                                minHeight: '30px', // ensures the content is taller than the container
                                            }}
                                        >

                                            {
                                                addedFiles.map(file => (
                                                    <div className="align_4_dataPolicy deletePolicy">
                                                        <span className="hoverPolicy">{file.name}</span>
                                                        <span className="marginPolicy hoverPolicy" onClick={() => { setAddedFiles(addedFiles.filter(list => list.id !== file.id)); setfileSize(fileSize - Number((file.size / (1024 * 1024)).toFixed(2))); }}>
                                                            <img
                                                                src="/kshemaImages/delete_symbol.png"
                                                                alt="delete"
                                                                height="18px"
                                                                width="auto"
                                                            />
                                                        </span>
                                                    </div>
                                                ))
                                            }
                                            {/* Add more content here */}
                                        </div>
                                    </div>
                                </>
                            )
                        }
                </div>           
            </div>
            </>
        )
       }
    </>
  )
};

export default FileUpload;